/** ========================================================================= *\
 * @prefab Powerbar
 * ========================================================================== */
import * as CONST from 'config';

export default class Powerbar extends Phaser.Group {

    /** Sprites --------------------------------------------------------------- */
    static Sprites = [
      { key: 'coin1',      fps: 1, scale: 1.00, power:"50" },
      { key: 'coin2',      fps: 1, scale: 1.00, power:"100" },
      { key: 'angpao',      fps: 1, scale: 1.00, power:"100" },
      { key: 'bone',      fps: 1, scale: 1.00, power:"SuperPow" },
      
    ];
  
    /** @constructor ---------------------------------------------------------- */
    constructor(game, x, y) {
      super(game);
  
      // Select random sprite
      const randomSprite = Powerbar.Sprites[Math.floor(Math.random() * Powerbar.Sprites.length)];
  
      // Create sprite
      const sprite = new Phaser.Sprite(game, x, y, randomSprite.key);
      sprite.anchor.setTo(0.5, 1);
      sprite.scale = new Phaser.Point(randomSprite.scale, randomSprite.scale);
      sprite.alive = true;
      sprite.health = 5;
  
      // Enable animations if supported
      sprite.animations.add('idle');
      sprite.animations.play('idle', randomSprite.fps || 1, true);
  
      this.Powerbar = this.add(sprite);
      this.Powerbar.power = randomSprite.power;
  
      // Enable physics
      // game.physics.arcade.enable(this);
      game.physics.arcade.enable(this.Powerbar);
      this.Powerbar.body.immovable = true;
      // Kill group when main sprite dies
      this.Powerbar.events.onKilled.add(() => { this.kill(); })

      // Kill sprite when out of world bounds
      this.Powerbar.checkWorldBounds = true;
      this.Powerbar.events.onOutOfBounds.add((pow)=>{pow.kill()},this);
    }
}


// WEBPACK FOOTER //
// ./js/prefabs/Powerbar.js